'use client'
import ErrorComponent from '@/shared/components/Error'

export default ErrorComponent
